export default __webpack_public_path__ + "static/media/smoke1.78074164.mp4";